var _require = require('./image'),
  getImageFilename = _require.getImageFilename,
  getImageUrl = _require.getImageUrl;
var MAX_THUMBNAIL_WIDTH = 640;
var MAX_THUMBNAIL_HEIGHT = 480;
var resizeThumbnail = function resizeThumbnail(imageHost) {
  return function (pathname, width, height) {
    return {
      url: getImageUrl(imageHost)({
        file_name: getImageFilename(pathname),
        width: width,
        height: height
      }, {
        maxWidth: MAX_THUMBNAIL_WIDTH,
        maxHeight: MAX_THUMBNAIL_HEIGHT
      }),
      width: MAX_THUMBNAIL_WIDTH,
      height: MAX_THUMBNAIL_HEIGHT
    };
  };
};
module.exports = {
  resizeThumbnail: resizeThumbnail,
  MAX_THUMBNAIL_WIDTH: MAX_THUMBNAIL_WIDTH,
  MAX_THUMBNAIL_HEIGHT: MAX_THUMBNAIL_HEIGHT
};